
export default function Start() {
  return (
    <>
      <p>
        Herzlich willkommen auf unserer „FLIK-Suche", der Recherche-Plattform zu
        wichtigen Eigenschaften von Anbauflächen für Biomasse in Deutschland im
        Rahmen der Nachhaltigkeitszertifizierung gemäß der revidierten Richtlinie
        (EU) 2018/2001.
      </p>

      <p>Die FLIK-Suche bietet Unterstützung bei der Frage,</p>
      <ul>
        <li>
          ob eine Anbaufläche für nachhaltig erzeugte Biomasse zum
          Referenzzeitpunkt 01. Januar 2008 den Status „Ackerfläche" hatte,
        </li>
        <li>
          ob die Anbaufläche in einem Schutzgebiet liegt, für das ggf. weitere
          Bewirtschaftungsauflagen existieren,
        </li>
        <li>in welchen NUTS2-Gebiet eine Anbaufläche liegt,</li>
        <li>
          ob die Anbaufläche ganz oder teilweise aus „organischem" Boden (mit
          hohem Kohlenstoffbestand) besteht und
        </li>
        <li>
          wie hoch der Anteil der Flächen mit organischem Boden in dem jeweiligen
          NUTS2-Gebiet ist.
        </li>
      </ul>

      <p>
        Die Richtlinie legt fest, dass zulässige Anbauflächen für nachhaltig
        erzeugte Biomasse zum Referenzzeitpunkt 01. Januar 2008 den Status
        „Ackerfläche" nachweisen müssen. Für Flächen, die zu diesem Zeitpunkt
        einen anderen Status aufweisen, z.B. Grünland, gelten zusätzliche
        Bestimmungen, wenn diese zu einem späteren Zeitpunkt als Anbaufläche
        genutzt werden sollen. Hierauf wird bei den betroffenen Flächen
        hingewiesen.
      </p>

      <p>
        Die Statusinformationen wurden auf Initiative des Deutschen Bauernverbands
        von den zuständigen Ämtern und Dienststellen von folgenden Bundesländern
        zur Verfügung gestellt:
      </p>

      <p>
        <strong>
          Baden-Württemberg, Bayern, Brandenburg, Hessen*, Mecklenburg-Vorpommern,
          Nordrhein-Westfalen, Niedersachsen, Rheinland-Pfalz, Sachsen-Anhalt,
          Sachsen und Thüringen
        </strong>
      </p>

      <p>
        Über die Funktion „Layers" in der oberen rechten Bildschirmecke kann
        gezielt ausgewählt werden, welche der o.a. Informationen angezeigt werden
        sollen. Diese sind farblich kodiert und können in ihrer Deckkraft variabel
        eingestellt werden, um so auch die dahinter liegende Karte/Luftbildaufnahme
        erkennen zu können.
      </p>

      <p>
        Mit Blick auf die NUTS2-Werte – typische THG-Emissionen von Anbaubiomasse
        – können Erzeuger jetzt mit Hilfe der FLIK-Suche erkennen, in welchem
        NUTS2-Gebiet sich ihre Anbauflächen befinden und - wenn nötig -
        nachweisen, ob diese Flächen ggf. auf „organischen Böden" liegen, wenn für
        das betreffende NUTS2-Gebiet gesonderte THG-Emissionswerte für diesen
        Bodentyp vorgeschrieben sind. Hierfür wurde auf die Daten der
        „Moorkulissen" des Thünen-Instituts zurückgegriffen.
      </p>

      {/* <p>
        Die verschiedenen Funktionen werden im Benutzerhandbuch näher beschrieben.
      </p> */}

      <p>
        Bei Fragen, Anregungen oder Problemen nutzen Sie bitte folgende
        E-Mailadresse{" "}
        <a href="mailto:support@flik-suche.de">support@flik-suche.de</a>.
      </p>

      <p>
        <strong>Viel Erfolg!</strong>
      </p>

      <p>
        <em>
          *Hinweise zu Hessen: das Land Hessen hat nur die FLIK mit dem Status
          „Grünland" übermittelt, so dass hier keine ausdrückliche Bestätigung von
          Ackerflächen möglich ist. Ebenso ist die Qualität der Hintergrundkarte
          (Auflösung) in Hessen begrenzt.
        </em>
      </p>
    </>
  );
}
